import generateWithAsyncActions from 'epic-alt-utils';
import alt from 'epic-fortnite-react/alt';

/**
 * SubscribeActions
 */

export default generateWithAsyncActions(alt, ['addUserToNewsletter']);
